import React, { useState } from 'react';
import classNameBind from 'classnames/bind';
import Spinner from '../../../Spinner';
import ActionList from '../../../ActionList';
import { TextField } from '../../../TextField';
import Popover from '../../../Popover';
import styles from './FilteredSelectInner.module.css';

const bindClasses = classNameBind.bind(styles);

const FilteredSelectInner = ({
  groups,
  search,
  isLoading,
  onItemSelected,
  dataId,
  current,
  onSearchChange,
  onSearchKeyDown,
  onToggle,
  isOpen,
  onScrolledDown,
  isLoadingLazy,
  renderAfterListElement,
  forceClosePopover,
  wordBreakingStyle,
  searchPlaceholder,
} = {}) => {
  const [lastHeight, setLastHeight] = useState(null);
  const scrollableContainer = React.useRef();

  const handleScroll = () => {
    const sc = scrollableContainer.current;
    if (!sc) {
      return;
    }

    const scrollPosition = sc.offsetHeight + sc.scrollTop;
    const isScrolledToBottom = scrollPosition >= sc.scrollHeight;

    if (isScrolledToBottom && scrollPosition !== lastHeight && !isLoadingLazy) {
      onScrolledDown();
      setLastHeight(scrollPosition);
    }
  };

  return (
    <div className={bindClasses('wrapper-ctn')} data-ppuc-id={dataId}>
      <Popover.Section padding="narrow">
        <TextField
          name="search"
          icon="search"
          value={search}
          onChange={e => onSearchChange(e, isOpen)}
          clearable
          autoFocus
          onKeyDown={e => onSearchKeyDown(e, onToggle, isOpen)}
          placeholder={searchPlaceholder}
          dataId={`${dataId}.search`}
        />
      </Popover.Section>
      <Popover.Section fixedHeight>
        <div
          onScroll={handleScroll}
          className={bindClasses({ 'scroll-container': groups.length > 0 })}
          ref={scrollableContainer}
        >
          {isLoading ? (
            <div className={bindClasses('spinner-ctn')}><Spinner size="medium" /></div>
          ) : (
            <>
              <ActionList
                groups={groups}
                onItemSelected={onItemSelected}
                // dataId={`${dataId}.options`} TODO: uncomment in PPUCC-378
                current={current}
                wordBreakingStyle={wordBreakingStyle}
              />
              {isLoadingLazy && <Spinner size="x-small" />}
            </>
          )}
        </div>
      </Popover.Section>
      {renderAfterListElement && renderAfterListElement(forceClosePopover)}
    </div>
  );
};

FilteredSelectInner.defaultProps = {
  dataId: 'FilteredSelectInner',
  onSearchKeyDown: () => {},
  isOpen: false,
  onToggle: () => {},
  wordBreakingStyle: 'break-all',
  searchPlaceholder: '',
};

export { FilteredSelectInner };
